import script from "./CartDeliveryGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartDeliveryGroup.vue?vue&type=script&setup=true&lang=ts"

import "./CartDeliveryGroup.vue?vue&type=style&index=0&id=fa5ea24c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa5ea24c"]])

export default __exports__